import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getZonas: ["payload"],
  getZonasLoading: null,
  getZonasSuccess: ["getZonasData"],
  getZonasFailure: ["getZonasError"],

  getProvincias: ["payload"],
  getProvinciasLoading: null,
  getProvinciasSuccess: ["getProvinciasData"],
  getProvinciasFailure: ["getProvinciasError"],

  getDiagnosticos: ["payload"],
  getDiagnosticosLoading: null,
  getDiagnosticosSuccess: ["getDiagnosticosData"],
  getDiagnosticosFailure: ["getDiagnosticosError"],
});

export { Types };

export default Creators;